import React, { Component } from 'react';
import './App.scss';
import '@assets/fonts/fonts.css';
import { Router } from './Router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '@store/actions/index';

import { library } from '@fortawesome/fontawesome-svg-core';
import ReactPixel from 'react-facebook-pixel';

import {
  faAngleDown,
  faAngleUp,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faChevronCircleLeft,
  faChevronCircleRight,
  faSpinner
} from '@fortawesome/pro-regular-svg-icons';
import {
  faCopyright,
  faSquare,
  faCheckSquare,
  faCheckCircle
} from '@fortawesome/free-regular-svg-icons';
import {
  faCircle,
  faBars,
  faPlus,
  faMinus,
  faTimes,
  faPlane,
  faMapMarkerAlt,
  faCalendarAlt,
  faClock,
  faTrash,
  faInfoCircle,
  faChevronLeft as solidChevronLeft,
  faChevronRight as solidChevronRight,
  faTimesCircle,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import {
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faCopyright,
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faTwitter,
  faCircle,
  faBars,
  faPlus,
  faMinus,
  faTimes,
  faAngleDown,
  faAngleUp,
  faSquare,
  faCheckSquare,
  faCheckCircle,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faPlane,
  faChevronCircleLeft,
  faChevronCircleRight,
  faSpinner,
  faMapMarkerAlt,
  faCalendarAlt,
  faClock,
  faTrash,
  faInfoCircle,
  solidChevronLeft,
  solidChevronRight,
  faTimesCircle,
  faCheck
);

// Facebook Pixel
if (window.location.hostname === 'www.jetsuite.com') {
  // if (true) {
  const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
  const options = {
    autoConfig: true, // set pixel's autoConfig
    debug: false // enable logs
  };
  ReactPixel.init('1420884328053740', advancedMatching, options);
  ReactPixel.pageView();
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageWidth: window.innerWidth,
      pageHeight: window.innerHeight,
      heightSm: window.innerHeight <= 780,
      modalActive: false
    };
  }

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current
    });
  };

  updateDimensions = () => {
    if (this.state.pageWidth !== window.innerWidth) {
      this.setState({
        pageWidth: window.innerWidth,
        pageHeight: window.innerHeight,
        heightSm: window.innerHeight <= 780
      });
    }
  };

  sessionHandle = () => {
    const authData = localStorage.getItem('auth');
    if (authData) {
      const validTo = localStorage.getItem('validTo');
      if (
        validTo === null ||
        parseInt(validTo, 10) < Math.floor(Date.now() / 1000)
      ) {
        this.props.onSessionExpiry();
      } else {
        localStorage.setItem('validTo', Math.floor(Date.now() / 1000) + 14400);
      }
    }
  };

  handleLetsConnet = () => {
    const element = document.getElementById('lets-connect-form');
    if (element === null) {
      return false;
    }
    if (
      window.location.pathname.indexOf('/jetsuite-experiences') >= 0 ||
      window.location.pathname === '/exclusive-experience'
    ) {
      element.classList.add('d-none');
    } else {
      element.classList.remove('d-none');
    }
  };

  componentDidUpdate(prevProps, prevState) {
    this.handleLetsConnet();
  }

  componentDidMount = () => {
    this.props.onTryAutoSignup();
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('click', this.sessionHandle);
    this.handleLetsConnet();
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('click', this.sessionHandle);
  };

  render() {
    return (
      <React.Fragment>
        <Router
          {...this.state}
          sliderImg={this.props.sliderImg}
          toggleModal={this.toggleModal}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onSessionExpiry: () => dispatch(actions.logout())
  };
};
export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(App)
);
//



// WEBPACK FOOTER //
// ./src/components/App.js